import Typography from '@/components/atoms/typography/typography';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import Row from '@/components/utilities/row/row';
import BrandTeasersItem from './brand-teasers-item/brand-teasers-item';
import styles from './brand-teasers.module.scss';

export interface BrandTeasersProps extends ModuleWrapperProps {
  /** The headline to display */
  headline: Content.Components['BrandTeasersModuleDto']['headline'];
  /** The teasers to display */
  teasers: Content.Components['BrandTeasersModuleDto']['teasers'];
}

const BrandTeasers = ({ headline, teasers, ...rest }: BrandTeasersProps) => (
  <ModuleWrapper {...rest} className={styles.component}>
    <Container className={styles.container}>
      <Typography className={styles.headline} tag="h2" tagStyle="displayMedium">
        {headline}
      </Typography>

      <Row className={styles.row}>
        {teasers.map((teaser, teaserIndex) => (
          <Column key={teaserIndex} width={{ tablet: 4 }}>
            <BrandTeasersItem {...teaser} />
          </Column>
        ))}
      </Row>
    </Container>
  </ModuleWrapper>
);

BrandTeasers.displayName = 'BrandTeasers';

export default BrandTeasers;
